<template>
    <div class="main">
       <themeTraining></themeTraining>
       <diagnosis :isHide="isHide"></diagnosis>
    </div>
</template>

<script>
	 import themeTraining from './themeTraining/themeTraining.vue'
	 import diagnosis from './diagnosis/diagnosis.vue'
    export default {
    	name:'main_index',
    	components:{  diagnosis, themeTraining },
        data() {
            return {
                isHide:false
            }
        },
        methods: {
        },
        watch: {
        },
        created() {
        }
    }
</script>

<style scoped>
    .main{
    }
</style>
